const WORKFLOW_MODELER = '/workflow-modeler';
const FORM_MODELER = '/form-modeler';
const MANAGE_COMPONENTS = '/form-modeler/components';
const RULE_MODELER = '/rule-modeler';
const CASE_MODELER = '/case-modeler';
const ACCOUNTS_MODELER = '/accounts/groups';
const ACCOUNT_USERS = '/accounts/users';
const PREFERENCES = '/preferences';
const MANAGE_THEMES = '/manage-themes';
const MANAGE_TEMPLATES = '/manage-templates';
const CASE_INBOX = '/caseInbox';
const OPEN_TICKET = '/open-ticket';
const SAVE_SUBMIT = '/save-submit-form';
const MANAGE_ARTIFACTS = '/manage-artifacts';
const MANAGE_CHECKLIST = '/manage-checklist';
const CHECKLIST_DASHBOARD = '/manage-checklist/dashboard';
const VIEW_TICKET = '/form/:formId/:label';
const UPLOAD_CSV = '/uploadcsv';
export {
    WORKFLOW_MODELER,
    FORM_MODELER,
    MANAGE_COMPONENTS,
    RULE_MODELER,
    CASE_MODELER,
    ACCOUNTS_MODELER,
    ACCOUNT_USERS,
    PREFERENCES,
    MANAGE_THEMES,
    MANAGE_TEMPLATES,
    CASE_INBOX,
    OPEN_TICKET,
    MANAGE_ARTIFACTS,
    MANAGE_CHECKLIST,
    CHECKLIST_DASHBOARD,
    SAVE_SUBMIT,
    VIEW_TICKET,
    UPLOAD_CSV,
};
